import React, { useState } from "react";

import CustomDropdownBase from "@src/sharedComponents/CustomDropdownBase/CustomDropdownBase";
import MenuOptionsWithCheckIfSelected, {
  DropdownMenuOption,
} from "@src/sharedComponents/CustomDropdownBase/MenuOptionsWithCheckIfSelected/MenuOptionsWithCheckIfSelected";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./BaseDropdown.module.css";

type BaseDropdownProps<T extends string> = {
  title?: string | React.ReactNode;
  curItemId?: string;
  curItemLabel?: string;
  onSelect: (el: DropdownMenuOption<T>) => void;
  options?: DropdownMenuOption<T>[];
  categoryWithOptions?: {
    category: string;
    options: DropdownMenuOption<T>[];
  }[];
  displayLabel2InCategoryWithOptions?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
  width?: number;
  height?: number;
  hideCheckmark?: boolean;
  customDropdownBaseClassName?: string;
  customDropdownBaseTextClassName?: string;
  customDropdownBaseIconClassName?: string;
  customDropdownBaseWidth?: number;
  optionsMenuClassName?: string;
  shouldRenderTooltip?: (optionLabel: string) => boolean;
};

function BaseDropdown<T extends string>({
  title,
  onSelect,
  curItemId,
  curItemLabel,
  options,
  categoryWithOptions,
  displayLabel2InCategoryWithOptions,
  isDisabled = false,
  isLoading,
  placeholder,
  width = 470,
  height,
  hideCheckmark,
  customDropdownBaseClassName,
  customDropdownBaseTextClassName,
  customDropdownBaseIconClassName,
  customDropdownBaseWidth,
  optionsMenuClassName,
  shouldRenderTooltip,
}: BaseDropdownProps<T>) {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  return (
    <>
      {typeof title === "string" ? (
        <Text
          variant="body"
          color={"textSubtle"}
          className={styles.dropdownHeader}
        >
          {title}
        </Text>
      ) : (
        title
      )}

      <CustomDropdownBase
        curItem={curItemLabel ? { value: curItemLabel } : undefined}
        showDropdown={showDropdown}
        setShowDropdown={setShowDropdown}
        isLoading={isLoading}
        isDisabled={isDisabled}
        width={customDropdownBaseWidth ? customDropdownBaseWidth : width}
        menuWidth={width}
        className={customDropdownBaseClassName}
        textClassName={customDropdownBaseTextClassName}
        iconClassName={customDropdownBaseIconClassName}
        optionsMenuClassName={optionsMenuClassName}
        placeholder={placeholder}
      >
        <MenuOptionsWithCheckIfSelected
          width={width}
          curItemId={curItemId}
          curItemName={curItemLabel}
          onSelect={(el) => {
            onSelect(el);
            setShowDropdown(false);
          }}
          options={options}
          categoryWithOptions={categoryWithOptions}
          displayLabel2InCategoryWithOptions={
            displayLabel2InCategoryWithOptions
          }
          hideCheckmark={hideCheckmark}
          maxHeight={height}
          shouldRenderTooltip={shouldRenderTooltip}
        />
      </CustomDropdownBase>
    </>
  );
}

export default BaseDropdown;
